var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    [
      _c("el-button", {
        staticStyle: { "margin-bottom": "10px" },
        attrs: { icon: "el-icon-plus", circle: "", size: "mini" },
        on: { click: _vm.addThreshold },
      }),
      _c(
        "div",
        { staticStyle: { "max-height": "50vh", "overflow-y": "auto" } },
        _vm._l(_vm.thresholdArr, function (fieldItem, fieldIndex) {
          return _c(
            "div",
            { key: fieldIndex, staticClass: "field-item" },
            [
              _c(
                "el-row",
                { staticStyle: { "margin-top": "6px" } },
                [
                  _c("span", { staticClass: "color-title" }, [
                    _vm._v(_vm._s(_vm.$t("chart.field"))),
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: { size: "mini" },
                      on: {
                        change: function ($event) {
                          return _vm.addField(fieldItem)
                        },
                      },
                      model: {
                        value: fieldItem.fieldId,
                        callback: function ($$v) {
                          _vm.$set(fieldItem, "fieldId", $$v)
                        },
                        expression: "fieldItem.fieldId",
                      },
                    },
                    _vm._l(_vm.fields, function (fieldOption) {
                      return _c(
                        "el-option",
                        {
                          key: fieldOption.id,
                          attrs: {
                            label: fieldOption.name,
                            value: fieldOption.id,
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { float: "left" } },
                            [
                              fieldOption.deType === 0
                                ? _c("svg-icon", {
                                    staticClass: "field-icon-text",
                                    attrs: { "icon-class": "field_text" },
                                  })
                                : _vm._e(),
                              fieldOption.deType === 1
                                ? _c("svg-icon", {
                                    staticClass: "field-icon-time",
                                    attrs: { "icon-class": "field_time" },
                                  })
                                : _vm._e(),
                              fieldOption.deType === 2 ||
                              fieldOption.deType === 3
                                ? _c("svg-icon", {
                                    staticClass: "field-icon-value",
                                    attrs: { "icon-class": "field_value" },
                                  })
                                : _vm._e(),
                              fieldOption.deType === 5
                                ? _c("svg-icon", {
                                    staticClass: "field-icon-location",
                                    attrs: { "icon-class": "field_location" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "left",
                                color: "#8492a6",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v(_vm._s(fieldOption.name))]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _c("el-button", {
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "10px",
                    },
                    attrs: {
                      type: "text",
                      icon: "el-icon-plus",
                      circle: "",
                      size: "mini",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addConditions(fieldItem)
                      },
                    },
                  }),
                  _c("el-button", {
                    staticStyle: { "margin-bottom": "10px", float: "right" },
                    attrs: { icon: "el-icon-delete", circle: "", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.removeThreshold(fieldIndex)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._l(fieldItem.conditions, function (item, index) {
                return _c(
                  "el-row",
                  { key: index, staticClass: "line-item" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { size: "mini" },
                            on: { change: _vm.changeThreshold },
                            model: {
                              value: item.term,
                              callback: function ($$v) {
                                _vm.$set(item, "term", $$v)
                              },
                              expression: "item.term",
                            },
                          },
                          _vm._l(fieldItem.options, function (group, idx) {
                            return _c(
                              "el-option-group",
                              { key: idx, attrs: { label: group.label } },
                              _vm._l(group.options, function (opt) {
                                return _c("el-option", {
                                  key: opt.value,
                                  attrs: { label: opt.label, value: opt.value },
                                })
                              }),
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { span: 10 },
                      },
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !item.term.includes("null") &&
                                !item.term.includes("empty") &&
                                item.term !== "between",
                              expression:
                                "!item.term.includes('null') && !item.term.includes('empty') && item.term !== 'between'",
                            },
                          ],
                          staticClass: "value-item",
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            placeholder: _vm.$t("chart.drag_block_label_value"),
                            size: "mini",
                            clearable: "",
                          },
                          on: { change: _vm.changeThreshold },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                        item.term === "between"
                          ? _c(
                              "span",
                              [
                                _c("el-input", {
                                  staticClass: "between-item",
                                  attrs: {
                                    placeholder: _vm.$t("chart.axis_value_min"),
                                    size: "mini",
                                    clearable: "",
                                  },
                                  on: { change: _vm.changeThreshold },
                                  model: {
                                    value: item.min,
                                    callback: function ($$v) {
                                      _vm.$set(item, "min", $$v)
                                    },
                                    expression: "item.min",
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { margin: "0 4px" } },
                                  [
                                    _vm._v(
                                      "≤" +
                                        _vm._s(
                                          _vm.$t("chart.drag_block_label_value")
                                        ) +
                                        "≤"
                                    ),
                                  ]
                                ),
                                _c("el-input", {
                                  staticClass: "between-item",
                                  attrs: {
                                    placeholder: _vm.$t("chart.axis_value_max"),
                                    size: "mini",
                                    clearable: "",
                                  },
                                  on: { change: _vm.changeThreshold },
                                  model: {
                                    value: item.max,
                                    callback: function ($$v) {
                                      _vm.$set(item, "max", $$v)
                                    },
                                    expression: "item.max",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                        },
                        attrs: { span: 4 },
                      },
                      [
                        _c("span", { staticClass: "color-title" }, [
                          _vm._v(_vm._s(_vm.$t("chart.textColor"))),
                        ]),
                        _c("el-color-picker", {
                          staticClass: "color-picker-style",
                          attrs: {
                            "show-alpha": "",
                            predefine: _vm.predefineColors,
                          },
                          on: { change: _vm.changeThreshold },
                          model: {
                            value: item.color,
                            callback: function ($$v) {
                              _vm.$set(item, "color", $$v)
                            },
                            expression: "item.color",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                        },
                        attrs: { span: 4 },
                      },
                      [
                        _c("span", { staticClass: "color-title" }, [
                          _vm._v(_vm._s(_vm.$t("chart.backgroundColor"))),
                        ]),
                        _c("el-color-picker", {
                          staticClass: "color-picker-style",
                          attrs: {
                            "show-alpha": "",
                            predefine: _vm.predefineColors,
                          },
                          on: { change: _vm.changeThreshold },
                          model: {
                            value: item.backgroundColor,
                            callback: function ($$v) {
                              _vm.$set(item, "backgroundColor", $$v)
                            },
                            expression: "item.backgroundColor",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 2 } },
                      [
                        _c("el-button", {
                          staticStyle: { float: "right" },
                          attrs: {
                            type: "text",
                            icon: "el-icon-delete",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeCondition(fieldItem, index)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        }),
        0
      ),
      _c("div", { staticClass: "tip" }, [
        _vm._v(_vm._s(_vm.$t("chart.table_threshold_tip"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }